/* istanbul ignore file --@preserve */

// generated from https://github.com/Esri/arcgis-pbf/blob/main/proto/FeatureCollection/FeatureCollection.proto
// code generated by pbf v4.0.1

export function readFeatureCollectionPBuffer(pbf: any, end?: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferField,
    { version: "", queryResult: undefined },
    end
  );
}
function _readFeatureCollectionPBufferField(tag: any, obj: any, pbf: any) {
  if (tag === 1) obj.version = pbf.readString();
  else if (tag === 2)
    obj.queryResult = readFeatureCollectionPBufferQueryResult(
      pbf,
      pbf.readVarint() + pbf.pos
    );
}
export function writeFeatureCollectionPBuffer(obj: any, pbf: any) {
  if (obj.version) pbf.writeStringField(1, obj.version);
  if (obj.queryResult)
    pbf.writeMessage(
      2,
      writeFeatureCollectionPBufferQueryResult,
      obj.queryResult
    );
}

export const FeatureCollectionPBufferGeometryType = {
  esriGeometryTypePoint: 0,
  esriGeometryTypeMultipoint: 1,
  esriGeometryTypePolyline: 2,
  esriGeometryTypePolygon: 3,
  esriGeometryTypeMultipatch: 4,
  esriGeometryTypeNone: 127,
  esriGeometryTypeEnvelope: 5
};

export const FeatureCollectionPBufferFieldType = {
  esriFieldTypeSmallInteger: 0,
  esriFieldTypeInteger: 1,
  esriFieldTypeSingle: 2,
  esriFieldTypeDouble: 3,
  esriFieldTypeString: 4,
  esriFieldTypeDate: 5,
  esriFieldTypeOID: 6,
  esriFieldTypeGeometry: 7,
  esriFieldTypeBlob: 8,
  esriFieldTypeRaster: 9,
  esriFieldTypeGUID: 10,
  esriFieldTypeGlobalID: 11,
  esriFieldTypeXML: 12,
  esriFieldTypeBigInteger: 13,
  esriFieldTypeDateOnly: 14,
  esriFieldTypeTimeOnly: 15,
  esriFieldTypeTimestampOffset: 16
};

export const FeatureCollectionPBufferSQLType = {
  sqlTypeBigInt: 0,
  sqlTypeBinary: 1,
  sqlTypeBit: 2,
  sqlTypeChar: 3,
  sqlTypeDate: 4,
  sqlTypeDecimal: 5,
  sqlTypeDouble: 6,
  sqlTypeFloat: 7,
  sqlTypeGeometry: 8,
  sqlTypeGUID: 9,
  sqlTypeInteger: 10,
  sqlTypeLongNVarchar: 11,
  sqlTypeLongVarbinary: 12,
  sqlTypeLongVarchar: 13,
  sqlTypeNChar: 14,
  sqlTypeNVarchar: 15,
  sqlTypeOther: 16,
  sqlTypeReal: 17,
  sqlTypeSmallInt: 18,
  sqlTypeSqlXml: 19,
  sqlTypeTime: 20,
  sqlTypeTimestamp: 21,
  sqlTypeTimestamp2: 22,
  sqlTypeTinyInt: 23,
  sqlTypeVarbinary: 24,
  sqlTypeVarchar: 25,
  sqlTypeTimestampWithTimezone: 26
};

export const FeatureCollectionPBufferQuantizeOriginPostion = {
  upperLeft: 0,
  lowerLeft: 1
};

export const FeatureCollectionPBufferSegmentType = {
  line: 0,
  arc: 1,
  bezier: 2,
  ellipticArc: 3
};

export function readFeatureCollectionPBufferSpatialReference(
  pbf: any,
  end: any
) {
  return pbf.readFields(
    _readFeatureCollectionPBufferSpatialReferenceField,
    { wkid: 0, latestWkid: 0, vcsWkid: 0, latestVcsWkid: 0, wkt: "", wkt2: "" },
    end
  );
}
function _readFeatureCollectionPBufferSpatialReferenceField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.wkid = pbf.readVarint();
  else if (tag === 2) obj.latestWkid = pbf.readVarint();
  else if (tag === 3) obj.vcsWkid = pbf.readVarint();
  else if (tag === 4) obj.latestVcsWkid = pbf.readVarint();
  else if (tag === 5) obj.wkt = pbf.readString();
  else if (tag === 6) obj.wkt2 = pbf.readString();
}
export function writeFeatureCollectionPBufferSpatialReference(
  obj: any,
  pbf: any
) {
  if (obj.wkid) pbf.writeVarintField(1, obj.wkid);
  if (obj.latestWkid) pbf.writeVarintField(2, obj.latestWkid);
  if (obj.vcsWkid) pbf.writeVarintField(3, obj.vcsWkid);
  if (obj.latestVcsWkid) pbf.writeVarintField(4, obj.latestVcsWkid);
  if (obj.wkt) pbf.writeStringField(5, obj.wkt);
  if (obj.wkt2) pbf.writeStringField(6, obj.wkt2);
}

export function readFeatureCollectionPBufferField(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferFieldField,
    {
      name: "",
      fieldType: 0,
      alias: "",
      sqlType: 0,
      domain: "",
      defaultValue: ""
    },
    end
  );
}
function _readFeatureCollectionPBufferFieldField(tag: any, obj: any, pbf: any) {
  if (tag === 1) obj.name = pbf.readString();
  else if (tag === 2) obj.fieldType = pbf.readVarint();
  else if (tag === 3) obj.alias = pbf.readString();
  else if (tag === 4) obj.sqlType = pbf.readVarint();
  else if (tag === 5) obj.domain = pbf.readString();
  else if (tag === 6) obj.defaultValue = pbf.readString();
}
export function writeFeatureCollectionPBufferField(obj: any, pbf: any) {
  if (obj.name) pbf.writeStringField(1, obj.name);
  if (obj.fieldType) pbf.writeVarintField(2, obj.fieldType);
  if (obj.alias) pbf.writeStringField(3, obj.alias);
  if (obj.sqlType) pbf.writeVarintField(4, obj.sqlType);
  if (obj.domain) pbf.writeStringField(5, obj.domain);
  if (obj.defaultValue) pbf.writeStringField(6, obj.defaultValue);
}

export function readFeatureCollectionPBufferGeometryField(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferGeometryFieldField,
    { field: undefined, geometryType: 0 },
    end
  );
}
function _readFeatureCollectionPBufferGeometryFieldField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1)
    obj.field = readFeatureCollectionPBufferField(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 2) obj.geometryType = pbf.readVarint();
}
export function writeFeatureCollectionPBufferGeometryField(obj: any, pbf: any) {
  if (obj.field)
    pbf.writeMessage(1, writeFeatureCollectionPBufferField, obj.field);
  if (obj.geometryType) pbf.writeVarintField(2, obj.geometryType);
}

export function readFeatureCollectionPBufferEnvelope(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferEnvelopeField,
    { XMin: 0, YMin: 0, XMax: 0, YMax: 0, SpatialReference: undefined },
    end
  );
}
function _readFeatureCollectionPBufferEnvelopeField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.XMin = pbf.readDouble();
  else if (tag === 2) obj.YMin = pbf.readDouble();
  else if (tag === 3) obj.XMax = pbf.readDouble();
  else if (tag === 4) obj.YMax = pbf.readDouble();
  else if (tag === 5)
    obj.SpatialReference = readFeatureCollectionPBufferSpatialReference(
      pbf,
      pbf.readVarint() + pbf.pos
    );
}
export function writeFeatureCollectionPBufferEnvelope(obj: any, pbf: any) {
  if (obj.XMin) pbf.writeDoubleField(1, obj.XMin);
  if (obj.YMin) pbf.writeDoubleField(2, obj.YMin);
  if (obj.XMax) pbf.writeDoubleField(3, obj.XMax);
  if (obj.YMax) pbf.writeDoubleField(4, obj.YMax);
  if (obj.SpatialReference)
    pbf.writeMessage(
      5,
      writeFeatureCollectionPBufferSpatialReference,
      obj.SpatialReference
    );
}

export function readFeatureCollectionPBufferValue(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferValueField,
    {
      string_value: "",
      value_type: undefined,
      float_value: 0,
      double_value: 0,
      sint_value: 0,
      uint_value: 0,
      int64_value: 0,
      uint64_value: 0,
      sint64_value: 0,
      bool_value: false,
      null_value: false,
      index: 0
    },
    end
  );
}
function _readFeatureCollectionPBufferValueField(tag: any, obj: any, pbf: any) {
  if (tag === 1) {
    obj.string_value = pbf.readString();
    obj.value_type = "string_value";
  } else if (tag === 2) {
    obj.float_value = pbf.readFloat();
    obj.value_type = "float_value";
  } else if (tag === 3) {
    obj.double_value = pbf.readDouble();
    obj.value_type = "double_value";
  } else if (tag === 4) {
    obj.sint_value = pbf.readSVarint();
    obj.value_type = "sint_value";
  } else if (tag === 5) {
    obj.uint_value = pbf.readVarint();
    obj.value_type = "uint_value";
  } else if (tag === 6) {
    obj.int64_value = pbf.readVarint(true);
    obj.value_type = "int64_value";
  } else if (tag === 7) {
    obj.uint64_value = pbf.readVarint();
    obj.value_type = "uint64_value";
  } else if (tag === 8) {
    obj.sint64_value = pbf.readSVarint();
    obj.value_type = "sint64_value";
  } else if (tag === 9) {
    obj.bool_value = pbf.readBoolean();
    obj.value_type = "bool_value";
  } else if (tag === 10) {
    obj.null_value = pbf.readBoolean();
    obj.value_type = "null_value";
  } else if (tag === 11) obj.index = pbf.readVarint();
}
export function writeFeatureCollectionPBufferValue(obj: any, pbf: any) {
  if (obj.string_value != null) pbf.writeStringField(1, obj.string_value);
  if (obj.float_value != null) pbf.writeFloatField(2, obj.float_value);
  if (obj.double_value != null) pbf.writeDoubleField(3, obj.double_value);
  if (obj.sint_value != null) pbf.writeSVarintField(4, obj.sint_value);
  if (obj.uint_value != null) pbf.writeVarintField(5, obj.uint_value);
  if (obj.int64_value != null) pbf.writeVarintField(6, obj.int64_value);
  if (obj.uint64_value != null) pbf.writeVarintField(7, obj.uint64_value);
  if (obj.sint64_value != null) pbf.writeSVarintField(8, obj.sint64_value);
  if (obj.bool_value != null) pbf.writeBooleanField(9, obj.bool_value);
  if (obj.null_value != null) pbf.writeBooleanField(10, obj.null_value);
  if (obj.index) pbf.writeVarintField(11, obj.index);
}

export function readFeatureCollectionPBufferGeometry(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferGeometryField,
    { geometryType: 0, lengths: [], coords: [], ids: [] },
    end
  );
}
function _readFeatureCollectionPBufferGeometryField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.geometryType = pbf.readVarint();
  else if (tag === 2) pbf.readPackedVarint(obj.lengths);
  else if (tag === 3) pbf.readPackedSVarint(obj.coords);
  else if (tag === 4) pbf.readPackedSVarint(obj.ids);
}
export function writeFeatureCollectionPBufferGeometry(obj: any, pbf: any) {
  if (obj.geometryType) pbf.writeVarintField(1, obj.geometryType);
  if (obj.lengths) pbf.writePackedVarint(2, obj.lengths);
  if (obj.coords) pbf.writePackedSVarint(3, obj.coords);
  if (obj.ids) pbf.writePackedSVarint(4, obj.ids);
}

export function readFeatureCollectionPBufferCurveGeometry(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferCurveGeometryField,
    { geometryType: 0, parts: [], segmentSets: [], coords: [] },
    end
  );
}
function _readFeatureCollectionPBufferCurveGeometryField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.geometryType = pbf.readVarint();
  else if (tag === 2) pbf.readPackedVarint(obj.parts);
  else if (tag === 3)
    obj.segmentSets.push(
      readFeatureCollectionPBufferSegmentSet(pbf, pbf.readVarint() + pbf.pos)
    );
  else if (tag === 4) pbf.readPackedSVarint(obj.coords);
}
export function writeFeatureCollectionPBufferCurveGeometry(obj: any, pbf: any) {
  if (obj.geometryType) pbf.writeVarintField(1, obj.geometryType);
  if (obj.parts) pbf.writePackedVarint(2, obj.parts);
  if (obj.segmentSets)
    for (const item of obj.segmentSets)
      pbf.writeMessage(3, writeFeatureCollectionPBufferSegmentSet, item);
  if (obj.coords) pbf.writePackedSVarint(4, obj.coords);
}

export function readFeatureCollectionPBufferSegmentSet(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferSegmentSetField,
    { type: 0, count: 0, parameters: [] },
    end
  );
}
function _readFeatureCollectionPBufferSegmentSetField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.type = pbf.readVarint();
  else if (tag === 2) obj.count = pbf.readVarint();
  else if (tag === 3) pbf.readPackedDouble(obj.parameters);
}
export function writeFeatureCollectionPBufferSegmentSet(obj: any, pbf: any) {
  if (obj.type) pbf.writeVarintField(1, obj.type);
  if (obj.count) pbf.writeVarintField(2, obj.count);
  if (obj.parameters) pbf.writePackedDouble(3, obj.parameters);
}

export function readFeatureCollectionPBufferesriShapeBuffer(
  pbf: any,
  end: any
) {
  return pbf.readFields(
    _readFeatureCollectionPBufferesriShapeBufferField,
    { bytes: undefined },
    end
  );
}
function _readFeatureCollectionPBufferesriShapeBufferField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.bytes = pbf.readBytes();
}
export function writeFeatureCollectionPBufferesriShapeBuffer(
  obj: any,
  pbf: any
) {
  if (obj.bytes != null) pbf.writeBytesField(1, obj.bytes);
}

export function readFeatureCollectionPBufferFeature(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferFeatureField,
    {
      attributes: [],
      geometry: undefined,
      compressed_geometry: undefined,
      shapeBuffer: undefined,
      curveGeometry: undefined,
      centroid: undefined,
      aggregateGeometries: [],
      envelope: undefined
    },
    end
  );
}
function _readFeatureCollectionPBufferFeatureField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1)
    obj.attributes.push(
      readFeatureCollectionPBufferValue(pbf, pbf.readVarint() + pbf.pos)
    );
  else if (tag === 2) {
    obj.geometry = readFeatureCollectionPBufferGeometry(
      pbf,
      pbf.readVarint() + pbf.pos
    );
    obj.compressed_geometry = "geometry";
  } else if (tag === 3) {
    obj.shapeBuffer = readFeatureCollectionPBufferesriShapeBuffer(
      pbf,
      pbf.readVarint() + pbf.pos
    );
    obj.compressed_geometry = "shapeBuffer";
  } else if (tag === 7) {
    obj.curveGeometry = readFeatureCollectionPBufferCurveGeometry(
      pbf,
      pbf.readVarint() + pbf.pos
    );
    obj.compressed_geometry = "curveGeometry";
  } else if (tag === 4)
    obj.centroid = readFeatureCollectionPBufferGeometry(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 5)
    obj.aggregateGeometries.push(
      readFeatureCollectionPBufferGeometry(pbf, pbf.readVarint() + pbf.pos)
    );
  else if (tag === 6)
    obj.envelope = readFeatureCollectionPBufferEnvelope(
      pbf,
      pbf.readVarint() + pbf.pos
    );
}
export function writeFeatureCollectionPBufferFeature(obj: any, pbf: any) {
  if (obj.attributes)
    for (const item of obj.attributes)
      pbf.writeMessage(1, writeFeatureCollectionPBufferValue, item);
  if (obj.geometry)
    pbf.writeMessage(2, writeFeatureCollectionPBufferGeometry, obj.geometry);
  if (obj.shapeBuffer)
    pbf.writeMessage(
      3,
      writeFeatureCollectionPBufferesriShapeBuffer,
      obj.shapeBuffer
    );
  if (obj.curveGeometry)
    pbf.writeMessage(
      7,
      writeFeatureCollectionPBufferCurveGeometry,
      obj.curveGeometry
    );
  if (obj.centroid)
    pbf.writeMessage(4, writeFeatureCollectionPBufferGeometry, obj.centroid);
  if (obj.aggregateGeometries)
    for (const item of obj.aggregateGeometries)
      pbf.writeMessage(5, writeFeatureCollectionPBufferGeometry, item);
  if (obj.envelope)
    pbf.writeMessage(6, writeFeatureCollectionPBufferEnvelope, obj.envelope);
}

export function readFeatureCollectionPBufferUniqueIdField(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferUniqueIdFieldField,
    { name: "", isSystemMaintained: false },
    end
  );
}
function _readFeatureCollectionPBufferUniqueIdFieldField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.name = pbf.readString();
  else if (tag === 2) obj.isSystemMaintained = pbf.readBoolean();
}
export function writeFeatureCollectionPBufferUniqueIdField(obj: any, pbf: any) {
  if (obj.name) pbf.writeStringField(1, obj.name);
  if (obj.isSystemMaintained) pbf.writeBooleanField(2, obj.isSystemMaintained);
}

export function readFeatureCollectionPBufferGeometryProperties(
  pbf: any,
  end: any
) {
  return pbf.readFields(
    _readFeatureCollectionPBufferGeometryPropertiesField,
    { shapeAreaFieldName: "", shapeLengthFieldName: "", units: "" },
    end
  );
}
function _readFeatureCollectionPBufferGeometryPropertiesField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.shapeAreaFieldName = pbf.readString();
  else if (tag === 2) obj.shapeLengthFieldName = pbf.readString();
  else if (tag === 3) obj.units = pbf.readString();
}
export function writeFeatureCollectionPBufferGeometryProperties(
  obj: any,
  pbf: any
) {
  if (obj.shapeAreaFieldName) pbf.writeStringField(1, obj.shapeAreaFieldName);
  if (obj.shapeLengthFieldName)
    pbf.writeStringField(2, obj.shapeLengthFieldName);
  if (obj.units) pbf.writeStringField(3, obj.units);
}

export function readFeatureCollectionPBufferServerGens(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferServerGensField,
    { minServerGen: 0, serverGen: 0 },
    end
  );
}
function _readFeatureCollectionPBufferServerGensField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.minServerGen = pbf.readVarint();
  else if (tag === 2) obj.serverGen = pbf.readVarint();
}
export function writeFeatureCollectionPBufferServerGens(obj: any, pbf: any) {
  if (obj.minServerGen) pbf.writeVarintField(1, obj.minServerGen);
  if (obj.serverGen) pbf.writeVarintField(2, obj.serverGen);
}

export function readFeatureCollectionPBufferScale(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferScaleField,
    { xScale: 0, yScale: 0, mScale: 0, zScale: 0 },
    end
  );
}
function _readFeatureCollectionPBufferScaleField(tag: any, obj: any, pbf: any) {
  if (tag === 1) obj.xScale = pbf.readDouble();
  else if (tag === 2) obj.yScale = pbf.readDouble();
  else if (tag === 3) obj.mScale = pbf.readDouble();
  else if (tag === 4) obj.zScale = pbf.readDouble();
}
export function writeFeatureCollectionPBufferScale(obj: any, pbf: any) {
  if (obj.xScale) pbf.writeDoubleField(1, obj.xScale);
  if (obj.yScale) pbf.writeDoubleField(2, obj.yScale);
  if (obj.mScale) pbf.writeDoubleField(3, obj.mScale);
  if (obj.zScale) pbf.writeDoubleField(4, obj.zScale);
}

export function readFeatureCollectionPBufferTranslate(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferTranslateField,
    { xTranslate: 0, yTranslate: 0, mTranslate: 0, zTranslate: 0 },
    end
  );
}
function _readFeatureCollectionPBufferTranslateField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.xTranslate = pbf.readDouble();
  else if (tag === 2) obj.yTranslate = pbf.readDouble();
  else if (tag === 3) obj.mTranslate = pbf.readDouble();
  else if (tag === 4) obj.zTranslate = pbf.readDouble();
}
export function writeFeatureCollectionPBufferTranslate(obj: any, pbf: any) {
  if (obj.xTranslate) pbf.writeDoubleField(1, obj.xTranslate);
  if (obj.yTranslate) pbf.writeDoubleField(2, obj.yTranslate);
  if (obj.mTranslate) pbf.writeDoubleField(3, obj.mTranslate);
  if (obj.zTranslate) pbf.writeDoubleField(4, obj.zTranslate);
}

export function readFeatureCollectionPBufferTransform(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferTransformField,
    { quantizeOriginPostion: 0, scale: undefined, translate: undefined },
    end
  );
}
function _readFeatureCollectionPBufferTransformField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.quantizeOriginPostion = pbf.readVarint();
  else if (tag === 2)
    obj.scale = readFeatureCollectionPBufferScale(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 3)
    obj.translate = readFeatureCollectionPBufferTranslate(
      pbf,
      pbf.readVarint() + pbf.pos
    );
}
export function writeFeatureCollectionPBufferTransform(obj: any, pbf: any) {
  if (obj.quantizeOriginPostion)
    pbf.writeVarintField(1, obj.quantizeOriginPostion);
  if (obj.scale)
    pbf.writeMessage(2, writeFeatureCollectionPBufferScale, obj.scale);
  if (obj.translate)
    pbf.writeMessage(3, writeFeatureCollectionPBufferTranslate, obj.translate);
}

export function readFeatureCollectionPBufferFeatureResult(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferFeatureResultField,
    {
      objectIdFieldName: "",
      uniqueIdField: undefined,
      globalIdFieldName: "",
      geohashFieldName: "",
      geometryProperties: undefined,
      serverGens: undefined,
      geometryType: 0,
      spatialReference: undefined,
      exceededTransferLimit: false,
      hasZ: false,
      hasM: false,
      transform: undefined,
      fields: [],
      values: [],
      features: [],
      geometryFields: []
    },
    end
  );
}
function _readFeatureCollectionPBufferFeatureResultField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.objectIdFieldName = pbf.readString();
  else if (tag === 2)
    obj.uniqueIdField = readFeatureCollectionPBufferUniqueIdField(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 3) obj.globalIdFieldName = pbf.readString();
  else if (tag === 4) obj.geohashFieldName = pbf.readString();
  else if (tag === 5)
    obj.geometryProperties = readFeatureCollectionPBufferGeometryProperties(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 6)
    obj.serverGens = readFeatureCollectionPBufferServerGens(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 7) obj.geometryType = pbf.readVarint();
  else if (tag === 8)
    obj.spatialReference = readFeatureCollectionPBufferSpatialReference(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 9) obj.exceededTransferLimit = pbf.readBoolean();
  else if (tag === 10) obj.hasZ = pbf.readBoolean();
  else if (tag === 11) obj.hasM = pbf.readBoolean();
  else if (tag === 12)
    obj.transform = readFeatureCollectionPBufferTransform(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 13)
    obj.fields.push(
      readFeatureCollectionPBufferField(pbf, pbf.readVarint() + pbf.pos)
    );
  else if (tag === 14)
    obj.values.push(
      readFeatureCollectionPBufferValue(pbf, pbf.readVarint() + pbf.pos)
    );
  else if (tag === 15)
    obj.features.push(
      readFeatureCollectionPBufferFeature(pbf, pbf.readVarint() + pbf.pos)
    );
  else if (tag === 16)
    obj.geometryFields.push(
      readFeatureCollectionPBufferGeometryField(pbf, pbf.readVarint() + pbf.pos)
    );
}
export function writeFeatureCollectionPBufferFeatureResult(obj: any, pbf: any) {
  if (obj.objectIdFieldName) pbf.writeStringField(1, obj.objectIdFieldName);
  if (obj.uniqueIdField)
    pbf.writeMessage(
      2,
      writeFeatureCollectionPBufferUniqueIdField,
      obj.uniqueIdField
    );
  if (obj.globalIdFieldName) pbf.writeStringField(3, obj.globalIdFieldName);
  if (obj.geohashFieldName) pbf.writeStringField(4, obj.geohashFieldName);
  if (obj.geometryProperties)
    pbf.writeMessage(
      5,
      writeFeatureCollectionPBufferGeometryProperties,
      obj.geometryProperties
    );
  if (obj.serverGens)
    pbf.writeMessage(
      6,
      writeFeatureCollectionPBufferServerGens,
      obj.serverGens
    );
  if (obj.geometryType) pbf.writeVarintField(7, obj.geometryType);
  if (obj.spatialReference)
    pbf.writeMessage(
      8,
      writeFeatureCollectionPBufferSpatialReference,
      obj.spatialReference
    );
  if (obj.exceededTransferLimit)
    pbf.writeBooleanField(9, obj.exceededTransferLimit);
  if (obj.hasZ) pbf.writeBooleanField(10, obj.hasZ);
  if (obj.hasM) pbf.writeBooleanField(11, obj.hasM);
  if (obj.transform)
    pbf.writeMessage(12, writeFeatureCollectionPBufferTransform, obj.transform);
  if (obj.fields)
    for (const item of obj.fields)
      pbf.writeMessage(13, writeFeatureCollectionPBufferField, item);
  if (obj.values)
    for (const item of obj.values)
      pbf.writeMessage(14, writeFeatureCollectionPBufferValue, item);
  if (obj.features)
    for (const item of obj.features)
      pbf.writeMessage(15, writeFeatureCollectionPBufferFeature, item);
  if (obj.geometryFields)
    for (const item of obj.geometryFields)
      pbf.writeMessage(16, writeFeatureCollectionPBufferGeometryField, item);
}

export function readFeatureCollectionPBufferCountResult(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferCountResultField,
    { count: 0 },
    end
  );
}
function _readFeatureCollectionPBufferCountResultField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.count = pbf.readVarint();
}
export function writeFeatureCollectionPBufferCountResult(obj: any, pbf: any) {
  if (obj.count) pbf.writeVarintField(1, obj.count);
}

export function readFeatureCollectionPBufferObjectIdsResult(
  pbf: any,
  end: any
) {
  return pbf.readFields(
    _readFeatureCollectionPBufferObjectIdsResultField,
    { objectIdFieldName: "", serverGens: undefined, objectIds: [] },
    end
  );
}
function _readFeatureCollectionPBufferObjectIdsResultField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) obj.objectIdFieldName = pbf.readString();
  else if (tag === 2)
    obj.serverGens = readFeatureCollectionPBufferServerGens(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 3) pbf.readPackedVarint(obj.objectIds);
}
export function writeFeatureCollectionPBufferObjectIdsResult(
  obj: any,
  pbf: any
) {
  if (obj.objectIdFieldName) pbf.writeStringField(1, obj.objectIdFieldName);
  if (obj.serverGens)
    pbf.writeMessage(
      2,
      writeFeatureCollectionPBufferServerGens,
      obj.serverGens
    );
  if (obj.objectIds) pbf.writePackedVarint(3, obj.objectIds);
}

export function readFeatureCollectionPBufferExtentCountResult(
  pbf: any,
  end: any
) {
  return pbf.readFields(
    _readFeatureCollectionPBufferExtentCountResultField,
    { extent: undefined, count: 0 },
    end
  );
}
function _readFeatureCollectionPBufferExtentCountResultField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1)
    obj.extent = readFeatureCollectionPBufferEnvelope(
      pbf,
      pbf.readVarint() + pbf.pos
    );
  else if (tag === 2) obj.count = pbf.readVarint();
}
export function writeFeatureCollectionPBufferExtentCountResult(
  obj: any,
  pbf: any
) {
  if (obj.extent)
    pbf.writeMessage(1, writeFeatureCollectionPBufferEnvelope, obj.extent);
  if (obj.count) pbf.writeVarintField(2, obj.count);
}

export function readFeatureCollectionPBufferQueryResult(pbf: any, end: any) {
  return pbf.readFields(
    _readFeatureCollectionPBufferQueryResultField,
    {
      featureResult: undefined,
      Results: undefined,
      countResult: undefined,
      idsResult: undefined,
      extentCountResult: undefined
    },
    end
  );
}
function _readFeatureCollectionPBufferQueryResultField(
  tag: any,
  obj: any,
  pbf: any
) {
  if (tag === 1) {
    obj.featureResult = readFeatureCollectionPBufferFeatureResult(
      pbf,
      pbf.readVarint() + pbf.pos
    );
    obj.Results = "featureResult";
  } else if (tag === 2) {
    obj.countResult = readFeatureCollectionPBufferCountResult(
      pbf,
      pbf.readVarint() + pbf.pos
    );
    obj.Results = "countResult";
  } else if (tag === 3) {
    obj.idsResult = readFeatureCollectionPBufferObjectIdsResult(
      pbf,
      pbf.readVarint() + pbf.pos
    );
    obj.Results = "idsResult";
  } else if (tag === 4) {
    obj.extentCountResult = readFeatureCollectionPBufferExtentCountResult(
      pbf,
      pbf.readVarint() + pbf.pos
    );
    obj.Results = "extentCountResult";
  }
}
export function writeFeatureCollectionPBufferQueryResult(obj: any, pbf: any) {
  if (obj.featureResult)
    pbf.writeMessage(
      1,
      writeFeatureCollectionPBufferFeatureResult,
      obj.featureResult
    );
  if (obj.countResult)
    pbf.writeMessage(
      2,
      writeFeatureCollectionPBufferCountResult,
      obj.countResult
    );
  if (obj.idsResult)
    pbf.writeMessage(
      3,
      writeFeatureCollectionPBufferObjectIdsResult,
      obj.idsResult
    );
  if (obj.extentCountResult)
    pbf.writeMessage(
      4,
      writeFeatureCollectionPBufferExtentCountResult,
      obj.extentCountResult
    );
}
